import { dark, light } from '@kep/kcds-foundation';

import type { Foundation } from '@kep/kcds-foundation';

export type ThemeMode = 'light' | 'dark';

export const getFoundation = (themeMode: ThemeMode): Foundation => {
  return themeMode === 'light' ? light : dark;
};
